import api from 'configs/api';
import { IGroupOptions } from 'interfaces/AllOmegaUsers';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IRequestResponse } from 'interfaces/RequestResponse';
import { IExportGridData } from 'interfaces/StockPosition';

const endpointUrl = 'msgraph-group';

export const getGroupOptions = async () => {
  const url = `${endpointUrl}`;
  const { data } = await api.get<IRequestListResponse<IGroupOptions>>(url);
  return data;
};

export const putGroupPermissionGrid = async params => {
  const url = `${endpointUrl}`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postExportGroupPermissionGrid = async (params: unknown) => {
  const url = `${endpointUrl}/excel`;
  const { data } = await api.post<IExportGridData>(url, params);
  return data;
};
